"use strict";

import angular from "angular";
import routes from "./author.routes";
import AuthorController from "./author.controller";

export default angular
  .module("dalApp.author", ["dalApp.auth", "ui.router"])
  .config(routes)
  .controller("AuthorController", AuthorController).name;



// WEBPACK FOOTER //
// ./client/app/author/index.js